export const ROLE_EXPLORER = 'explorer';

export const EXPLORER_ROLES = [ROLE_EXPLORER];
